export interface BridgeRoomState {
  floor: number;
  version: number;
  createdAt: number;
  updatedAt: number;
  updatedBy: string;
}

export interface BridgeCommand {
  commandId: string;
  roomId: string;
  state: 'pending' | 'claimed' | 'completed' | 'expired';
  payload: {
    type?: string;
    reason?: string;
    notation?: string;
    label?: string;
    target?: 'everyone' | 'self' | 'dm' | 'gm_only';
    showResults?: boolean;
  } | null;
  result: unknown;
}

interface BridgeEnvelope {
  ok?: boolean;
  error?: string;
  bridge?: string;
  command?: BridgeCommand | null;
  combat?: unknown;
  players?: unknown[];
  documents?: unknown[];
  roomState?: BridgeRoomState | null;
}

export async function bridgeRequest(secret: string, roomId: string, body: Record<string, unknown>): Promise<BridgeEnvelope> {
  const response = await fetch('/api/bridge', {
    method: 'POST',
    headers: { 'content-type': 'application/json', authorization: `Bearer ${secret}` },
    body: JSON.stringify({ ...body, roomId }),
    cache: 'no-store',
  });
  let data: BridgeEnvelope = {};
  try { data = await response.json() as BridgeEnvelope; }
  catch { return { ok: false, error: `Bridge returned HTTP ${response.status} with unreadable JSON.` }; }
  if (!response.ok) return { ok: false, error: data.error ?? `Bridge returned HTTP ${response.status}.` };
  return data;
}
